module.exports = __FOREMAN_VENDOR__REACT_INTL__;